import { Controller } from 'react-hook-form'
import * as z from 'zod'
import { Text } from '~/@mid_ui/typography/Text'
import { ScoreRadio } from '~/@mid_ui-form/score-radio/ScoreRadio'
import { ScoreRadioGroup } from '~/@mid_ui-form/score-radiu-group/ScoreRadioGroup'
import { FormStep } from '~/@pages_onboarding/investor-analysis/_analysis-form/FormStep'
import { StepTitle } from '~/@pages_onboarding/investor-analysis/_analysis-form/StepTitle'
import { useFormStepUnsophisticated } from '../../form-step-unsophisticated/useFormStepUnsophisticated'
import { useQuestionsV1 } from '../../../questions'

const step2Schema = z.object({
  riskAttitude: z.object({
    value: z.enum([
      'minimizeRiskPreferSteadyReturns',
      'willingToAcceptHighRiskForPotentialHigherReturns',
      'openToExtremeRiskStrategiesForHighReturns',
    ]),
    score: z.number(),
  }),
})

export type Step2Data = z.infer<typeof step2Schema>

export function Step2() {
  const { onStepCompleted, formData } = useFormStepUnsophisticated()
  const { unsophisticated: unsophisticatedQuestions } = useQuestionsV1()

  return (
    <FormStep
      defaultValues={formData}
      schema={step2Schema}
      onStepCompleted={onStepCompleted}
      render={({ control }) => (
        <>
          <StepTitle>
            {unsophisticatedQuestions.riskAttitude.question.label}
          </StepTitle>
          <Text className="font-medium">
            Investovanie je neoddeliteľne spojené s rizikom a pre dosiahnutie
            výnosov je potrebné prijať určitú mieru rizika. Označte, ktorý z
            nasledujúcich výrokov najlepšie opisuje váš postoj k riziku:
          </Text>
          <Controller
            control={control}
            name="riskAttitude"
            render={({ field }) => (
              <ScoreRadioGroup
                value={field.value}
                onValueChange={field.onChange}>
                {Object.entries(
                  unsophisticatedQuestions.riskAttitude.answers
                ).map(([value, answer]) => (
                  <ScoreRadio
                    key={value}
                    score={answer.score}
                    value={value}
                    label={answer.label}
                  />
                ))}
              </ScoreRadioGroup>
            )}
          />
        </>
      )}
    />
  )
}
